import { z } from '@harvestiq/zod';

/**
 * Schema for Twilio incoming SMS webhook payload
 * @see https://www.twilio.com/docs/messaging/guides/webhook-request
 */

export const twilioIncomingSmsWebhookSchema = z.object({
  MessageSid: z.string(),
  Body: z.string(),
  From: z.string(), // The customer's phone number
  To: z.string(), // The agency's Twilio number
  AccountSid: z.string(),

  // Optional fields that Twilio may send
  MessagingServiceSid: z.string().optional(),
  NumMedia: z.string().optional(),
  NumSegments: z.string().optional(),
  SmsStatus: z.string().optional(),
  SmsSid: z.string().optional(),
  SmsMessageSid: z.string().optional(),
  FromCity: z.string().optional(),
  FromState: z.string().optional(),
  FromZip: z.string().optional(),
  FromCountry: z.string().optional(),
  ToCity: z.string().optional(),
  ToState: z.string().optional(),
  ToZip: z.string().optional(),
  ToCountry: z.string().optional(),
});

export type TwilioIncomingSmsWebhook = z.infer<
  typeof twilioIncomingSmsWebhookSchema
>;

export const SmsCommands = {
  SUBSCRIBE: 'SUBSCRIBE',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
} as const;

export type SmsCommandType = (typeof SmsCommands)[keyof typeof SmsCommands];
